// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

export const PreventionControlStatusSchema = z.enum(['generating','staged','activating','active','advisory','rejected','failed','removed','expired','drifted'] as const);

export type PreventionControlStatusType = `${z.infer<typeof PreventionControlStatusSchema>}`

export default PreventionControlStatusSchema;
